import React from 'react';
import Footer from '../../components/layout/Footer/Footer';
import Header from "../../../src/Component/header"
import '../../styles/layouts/MainLayout.scss';
import HeaderHero from '../../../src/Component/header';

const MainLayout = ({ children }) => {
  return (
    <div className="main-layout">
     <HeaderHero/>
      <main className="main-content">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;